import { render, staticRenderFns } from "./SpecialInitiativesModulesTable.vue?vue&type=template&id=66a06a2c&scoped=true&"
import script from "./SpecialInitiativesModulesTable.vue?vue&type=script&lang=ts&"
export * from "./SpecialInitiativesModulesTable.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialInitiativesModulesTable.vue?vue&type=style&index=0&id=66a06a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a06a2c",
  null
  
)

export default component.exports